/**
 * Battery Fields - Battery capacity configuration for power sources
 */

import React from 'react';
import { Box, Flex, Text, TextField, Checkbox } from '@radix-ui/themes';
import { DeviceTemplate } from '../../types';

interface BatteryFieldsProps {
  template: Partial<DeviceTemplate>;
  onChange: (updated: Partial<DeviceTemplate>) => void;
}

const BatteryFields: React.FC<BatteryFieldsProps> = ({ template, onChange }) => {
  const batteryCapacity = template.batteryCapacity;

  return (
    <Box>
      <Flex align="center" gap="2" mb="2">
        <Checkbox
          checked={!!batteryCapacity}
          onCheckedChange={(checked) => {
            if (checked) {
              onChange({ ...template, batteryCapacity: { capacityWh: 0, voltage: 12 } });
            } else {
              onChange({ ...template, batteryCapacity: undefined });
            }
          }}
        />
        <Text as="label" size="2" weight="bold">
          Battery Mode (for runtime calculations)
        </Text>
      </Flex>
      {batteryCapacity && (
        <Box p="3" style={{ backgroundColor: 'var(--gray-2)', borderRadius: 'var(--radius-2)' }}>
          <Flex gap="2">
            <Box style={{ flex: 1 }}>
              <Text as="label" size="1">Capacity (Wh)</Text>
              <TextField.Root
                type="number"
                step="0.1"
                placeholder="e.g., 150"
                value={batteryCapacity.capacityWh}
                onChange={(e) => onChange({
                  ...template,
                  batteryCapacity: { ...batteryCapacity, capacityWh: parseFloat(e.target.value) || 0 }
                })}
                mt="1"
              />
            </Box>
            <Box style={{ flex: 1 }}>
              <Text as="label" size="1">Battery Voltage (V)</Text>
              <TextField.Root
                type="number"
                step="0.1"
                value={batteryCapacity.voltage}
                onChange={(e) => onChange({
                  ...template,
                  batteryCapacity: { ...batteryCapacity, voltage: parseFloat(e.target.value) || 0 }
                })}
                mt="1"
              />
            </Box>
          </Flex>
          <Text size="1" color="gray" mt="2">
            Battery runtime will be calculated based on total rig power draw
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default BatteryFields;
